/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */

export interface CreateApplicationDraftRequest {
  draftType: number;
  /** @nullable */
  formData?: string;
}
